<script>
    export let fill = '#000'
</script>

<style>
    svg#event-top-text-icons {
        position: absolute;
        top: 55px;
        left: 18px;
        width: 372.05px;
        height: 372px;
    }

    .cls-1,
    .cls-11,
    .cls-28 {
        fill: none;
    }

    .cls-15,
    .cls-2,
    .cls-29,
    .cls-3,
    .cls-4 {
        fill: #fff;
    }

    .cls-2 {
        fill-rule: evenodd;
    }

    .cls-3 {
        font-size: 16px;
    }

    .cls-3,
    .cls-4 {
        font-family: AvenirNext-Regular, Avenir Next;
    }

    .cls-4 {
        font-size: 12px;
    }

    .cls-5 {
        letter-spacing: -0.06em;
    }

    .cls-6 {
        letter-spacing: -0.02em;
    }

    .cls-7 {
        letter-spacing: -0.01em;
    }

    .cls-8 {
        letter-spacing: 0em;
    }

    .cls-9 {
        clip-path: url(#clip-path);
    }

    .cls-10 {
        fill: #5a5b5d;
    }

    .cls-11,
    .cls-28 {
        stroke: #d1d0d0;
        stroke-linecap: round;
    }

    .cls-11,
    .cls-28,
    .cls-29 {
        stroke-miterlimit: 10;
    }

    .cls-11 {
        stroke-width: 0.91px;
    }

    .cls-12 {
        clip-path: url(#clip-path-3);
    }

    .cls-13 {
        fill: #070707;
    }

    .cls-14 {
        clip-path: url(#clip-path-5);
    }

    .cls-16 {
        fill: #c8c8c8;
    }

    .cls-17 {
        fill: #151515;
    }

    .cls-18 {
        fill: #272626;
    }

    .cls-19 {
        fill: #515252;
    }

    .cls-20 {
        fill: #e7e6e6;
    }

    .cls-21 {
        fill: #d9d9d9;
    }

    .cls-22 {
        fill: #b9b8b8;
    }

    .cls-23 {
        fill: #767676;
    }

    .cls-24 {
        fill: #d1d0d0;
    }

    .cls-25 {
        fill: gray;
    }

    .cls-26 {
        fill: #b3b4b4;
    }

    .cls-27 {
        fill: #231f20;
    }

    .cls-28 {
        stroke-width: 0.45px;
    }

    .cls-29 {
        stroke: #000;
        stroke-width: 0.71px;
    }

    /* .cls-1,
    .cls-11,
    .cls-28 {
        fill: transparent;
    }
    .cls-15,
    .cls-2,
    .cls-3,
    .cls-4 {
        fill: #fff;
    }
    .cls-2 {
        fill-rule: evenodd;
    }
    .cls-3 {
        font-size: 16px;
    }
    .cls-3,
    .cls-4 {
        font-family: AvenirNext-Regular, Avenir Next;
    }
    .cls-4 {
        font-size: 12px;
    }
    .cls-5 {
        letter-spacing: -0.06em;
    }
    .cls-6 {
        letter-spacing: -0.02em;
    }
    .cls-7 {
        letter-spacing: -0.01em;
    }
    .cls-8 {
        letter-spacing: 0em;
    }
    .cls-9 {
        clip-path: url(#clip-path);
    }
    .cls-10 {
        fill: #5a5b5d;
    }
    .cls-11,
    .cls-28 {
        stroke: #d1d0d0;
        stroke-linecap: round;
        stroke-miterlimit: 10;
    }
    .cls-11 {
        stroke-width: 0.91px;
    }
    .cls-12 {
        clip-path: url(#clip-path-3);
    }
    .cls-13 {
        fill: #070707;
    }
    .cls-14 {
        clip-path: url(#clip-path-5);
    }
    .cls-16 {
        fill: #c8c8c8;
    }
    .cls-17 {
        fill: #151515;
    }
    .cls-18 {
        fill: #272626;
    }
    .cls-19 {
        fill: #515252;
    }
    .cls-20 {
        fill: #e7e6e6;
    }
    .cls-21 {
        fill: #d9d9d9;
    }
    .cls-22 {
        fill: #b9b8b8;
    }
    .cls-23 {
        fill: #767676;
    }
    .cls-24 {
        fill: #d1d0d0;
    }
    .cls-25 {
        fill: gray;
    }
    .cls-26 {
        fill: #b3b4b4;
    }
    .cls-27 {
        fill: #231f20;
    }
    .cls-28 {
        stroke-width: 0.45px;
    }
    .cls-29 {
        fill: #ffe027;
    }
    .cls-30 {
        fill: #ce8d51;
    }
    .cls-31 {
        fill: #a35d24;
    }
    .cls-32 {
        fill: #eaaa75;
    }
    .cls-33 {
        opacity: 0.3;
    } */
</style>

<svg
    id="event-top-text-icons"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 372.05 372.55"
>
    <defs>
        <clipPath id="clip-path">
            <rect class="cls-1" x="337.01" y="31.16" width="35.04" height="42.35" />
        </clipPath>
        <clipPath id="clip-path-3">
            <path
                class="cls-1"
                d="M354.92,31.16c-9.08,0-16.86,3.26-17.11,3.94-1.23,22.12,7.86,34.16,16.9,36.23,0,0,18.66-7,16.75-36A33.79,33.79,0,0,0,354.92,31.16Z"
            />
        </clipPath>
        <clipPath id="clip-path-5">
            <rect class="cls-1" x="337.01" y="34.65" width="34.53" height="35.54" />
        </clipPath>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
            <!-- <polygon class="cls-2" points="325.99 196.22 327.21 197.41 332.98 191.77 327.21 186.12 325.99 187.31 330.55 191.77 325.99 196.22"/>
            <polygon class="cls-2" points="325.99 239.89 327.21 241.08 332.98 235.43 327.21 229.78 325.99 230.97 330.55 235.43 325.99 239.89"/>
            <polygon class="cls-2" points="325.99 283.62 327.21 284.81 332.98 279.16 327.21 273.52 325.99 274.71 330.55 279.16 325.99 283.62"/>
            <polygon class="cls-2" points="325.99 327.63 327.21 328.82 332.98 323.17 327.21 317.52 325.99 318.71 330.55 323.17 325.99 327.63"/>
            <polygon class="cls-2" points="325.99 371.36 327.21 372.55 332.98 366.9 327.21 361.26 325.99 362.45 330.55 366.9 325.99 371.36"/> -->
            <polygon class="cls-2" points="10.38 5.42 8.58 3.65 0 12.04 8.58 20.43 10.38 18.66 3.62 12.04 10.38 5.42" />
            <text class="cls-3" transform="translate(156.93 18.02)">1/29/21</text>
            <text class="cls-3" transform="translate(255.93 148.08)">TWITTER</text>
            <text class="cls-4" transform="translate(318.4 118.04)">
                <tspan class="cls-5">A</tspan>
                <tspan x="7.68" y="0">TU</tspan>
            </text>
            <text class="cls-4" transform="translate(22.37 118.04)">Opponent</text>
            <text class="cls-3" transform="translate(36.35 148.08)">EVENT INFO</text>
            <text class="cls-4" transform="translate(278.72 16.84)">
                player st
                <tspan class="cls-7" x="46.22" y="0">a</tspan>
                <tspan class="cls-8" x="52.51" y="0">ts</tspan>
            </text>
            <g id="Artwork_1" data-name="Artwork 1">
                <g class="cls-9">
                    <g class="cls-9">
                        <path
                            class="cls-10"
                            d="M356.11,35.74a31.43,31.43,0,0,1,15.36,3.91C373.24,66.51,355.92,73,355.92,73c-8.4-1.92-16.83-13.1-15.69-33.63.23-.64,7.46-3.65,15.88-3.66"
                        />
                        <path
                            class="cls-11"
                            d="M356.11,35.74a31.43,31.43,0,0,1,15.36,3.91C373.24,66.51,355.92,73,355.92,73c-8.4-1.92-16.83-13.1-15.69-33.63C340.46,38.76,347.69,35.75,356.11,35.74Z"
                        />
                        <path d="M348.12,67.45a14.32,14.32,0,0,0,7.76,5.11s17.36-6,15.59-32.91Z" />
                    </g>
                    <g class="cls-12">
                        <path
                            class="cls-13"
                            d="M363.9,54.84c4.48-3.42,6.82-10.67,7.63-15.39,1.69,10.61-8.8,27.1-14.06,28.92s-5.29,2-8.45,1.74c.29-.14-.06-.94.72-.63.24.1.65-.23,1-.36L350.5,69l.09-.15.28-.16h.19l.2-.48.14-.12.82-.17.15-.55,0,0,0,0,.59-.47.27-.61c.22-.12.44.55.65,0,0-.11,0-.22,0-.33.15-.13.38-.23.44-.39.47-1.46.46-1.46,1.3-1.24a.14.14,0,0,0,.11,0l.3-.45a4.06,4.06,0,0,0-.14.76c0,.12.16.25.25.37.3-.77,1.37-1,1.45-1.9l0,0c.88.43.69-.34.82-.75h.44a2.33,2.33,0,0,1,.17.26,3.71,3.71,0,0,1,.43-1,2.06,2.06,0,0,0,.41-1.58c.34.66.33-.13.52-.12l-.27-.55.62-.66c0-.09,0-.17,0-.25h0c0-.18,0-.36,0-.54l.1-.14.27-.12-.22-.24-.17-.32c-.25-.65,1.39-.49.6-1.38l-.11-.21c.54,0,.17-.4.21-.62l0-.23.07-.16a.11.11,0,0,1,.07-.06c1.12-.72,2.24.59,2.32.47"
                        />
                    </g>
                    <g class="cls-9">
                        <g class="cls-14">
                            <path
                                class="cls-15"
                                d="M345.55,63.88l-4.37-2.12-3.48-2.38-.17-.9s-2-10,4.74-15.58,29.05-3.41,29.05-3.41.5,9.15-4.44,16.5S359,66,359,66l-5.9,2.66-4.4.52L346.25,67c-.14,0-.36.26-.46.35s-.24.07-.2-.06Z"
                            />
                            <path
                                class="cls-16"
                                d="M362,54.23s-1.33.27-1.41,1.42-2,3.4-2.77,3.8a10,10,0,0,1-4.67.65c-1.33-.27-1.16-2.32-1.58-2.71s1.25-3.47-.35-1.4a4,4,0,0,1-3.39,1.85l2.72,8.88L348,68.24l.37.36-.38.15c-.44-.3-.95.42-1.38.12l-.35-.08c.27.8,1.05.93,1.69,1.23l1.09.17.71-.45h0l3.55-1.66,4.45-2.71,3.89-7.59Z"
                            />
                            <path
                                class="cls-17"
                                d="M352.19,50.34a19.33,19.33,0,0,0,.05,3.52c0,1.19-.93,1.17-1.74,1.3-2.69-.09-3.81-2.57-5.56-4-.76-.62.6-2.34,1.42-3.34s1.95-.92,3-.1,1.89,2,2.67,2,.41.29.2.63"
                            />
                            <path
                                class="cls-18"
                                d="M340.84,44.42a30.43,30.43,0,0,0-2.23,3.07,5.13,5.13,0,0,1-.55-1.45,20.18,20.18,0,0,1,0-3c.05-.65.57-.29.79-.16.61.36,2.46,1,2,1.55"
                            />
                            <path
                                class="cls-18"
                                d="M340.93,52l-1.71,2.08a5.45,5.45,0,0,1-.54-2.13,11.56,11.56,0,0,1,1.15-2.64c1.1.52.59,1.64,1.1,2.69"
                            />
                            <path class="cls-19" d="M346.66,58.31l-.31,0,.31,0" />
                            <path class="cls-20" d="M337,57s0,0,0,0h0s0,0,0,0" />
                            <path class="cls-21" d="M350.28,54.23l0,0,0,0h0" />
                            <path class="cls-22" d="M350.84,68.67l.21-.48-.21.48" />
                            <path class="cls-22" d="M350.38,68.84l.27-.16-.27.16" />
                            <path class="cls-19" d="M344.25,59.45l.48-.15-.48.15" />
                            <path class="cls-17" d="M350.19,60.2s-.08,0-.08,0,0,0,0-.08.07,0,.08,0,0,.05,0,.08" />
                            <polyline class="cls-23" points="340.72 60.2 340.72 60.19 340.72 60.2" />
                            <path class="cls-16" d="M339.28,59.67l0,.13-.09-.13h.13" />
                            <path
                                class="cls-16"
                                d="M353.4,64.7c.05.06.12.1.12.14s-.06.08-.09.12-.08-.07-.08-.1,0-.09,0-.16"
                            />
                            <path class="cls-16" d="M352.88,64.33c.07-.11.15-.22.22-.34l-.1.34h-.12" />
                            <path class="cls-16" d="M352.77,64.58v0" />
                            <path class="cls-24" d="M343,63.88l.06.22Z" />
                            <path
                                class="cls-24"
                                d="M342.78,61l-.59-.34s-.24,0-.27-.06a1.33,1.33,0,0,1-.3-.07l-.56.23c-.11-.05-.32-.22-.28-.33l.11-.23-.49,0-.15,0-1-.52-.38-.18-1.37-1.53c-.64.32.08,2.21,1.16,3.07.53.49,5.74,3.8,5.71,3.72l.08.26v-.77Z"
                            />
                            <path
                                class="cls-18"
                                d="M350.62,60.45c0-.22-.09-.8-.09-.88-.46,0-1,0-1-.68-.63-.14-1.42-.26-1.7-1-.41.12-1.33.44-1.43.45s-.51.58-.6.71c-.16.34-.51,0-.51,0l-.23,0c-.18.1-.26.1-.44.2s-.16.15-.32.2c-.06.27-.55.51-.72.41-.37,0-.72.08-1.09.08L342,60c-.29,0-.77.37-.14.73,1.23.4.92,1.57,1,2.5a2.38,2.38,0,0,1,1.59,1.72c1.1.79.25,2.12.85,3,.32.28.81.75,1,.84.42.51,3.3-.31,3.59-.83a6.34,6.34,0,0,0,1.19-2.26,10.34,10.34,0,0,0-.46-5.25"
                            />
                            <path class="cls-25" d="M349.07,50.62a.75.75,0,1,1-1.5,0,.75.75,0,0,1,1.5,0" />
                            <path class="cls-25" d="M340.12,52.14a.34.34,0,0,1-.67,0,.34.34,0,1,1,.67,0" />
                            <path
                                class="cls-15"
                                d="M350.36,66.81c-.25.41-2.47,1-2.78,1.11a5.12,5.12,0,0,1-1.11.18,1.18,1.18,0,0,1-.92-1.08c0-1.21.25-.07.67,0,.5-.14,1.26-.38,1.9-.58a2.1,2.1,0,0,1-.1-1.06c.13-.22.64.41.93.81,1.14-.34,1.51-.5,1.7-.28s0,.52-.29.93"
                            />
                            <path
                                class="cls-15"
                                d="M357.1,63.46l0,0-.09.11-.27.32-.29.33-.11.11,0,0h0a.18.18,0,0,1,0,0,.55.55,0,0,1,0-.16l0-.09.05-.11a.54.54,0,0,1,.05-.11l.07-.11a1,1,0,0,1,.33-.34.37.37,0,0,1,.14-.07l.07,0a.07.07,0,0,1,.09,0s0,.08,0,.09"
                            />
                            <path
                                class="cls-15"
                                d="M359.76,60.43l0,.06-.09.18a.67.67,0,0,1-.06.12l-.06.13-.07.14-.07.15-.25.57L359,62l0,.08h0v-.3s0-.09,0-.14l0-.16c0-.05,0-.11,0-.17s0-.11.05-.16a.87.87,0,0,1,.07-.17,1.11,1.11,0,0,1,.07-.16l.09-.13a.62.62,0,0,1,.09-.12,1.2,1.2,0,0,1,.15-.16l.07-.05a.07.07,0,1,1,.1.1"
                            />
                            <path
                                class="cls-15"
                                d="M353.65,65.7l0,0,.08-.12.26-.34.27-.34.1-.12,0,0h0v.06a1.43,1.43,0,0,1,0,.16l0,.1,0,.11a1.17,1.17,0,0,0-.05.11l-.06.11a1.24,1.24,0,0,1-.31.36l-.14.08-.07,0a.07.07,0,1,1-.07-.11"
                            />
                            <path
                                class="cls-26"
                                d="M348.12,65.47l0,.14,0,.15,0,.16c0,.12.06.23.08.32l0,.1v0h0l-.09-.12-.07-.14-.06-.17a1.06,1.06,0,0,1,0-.33.39.39,0,0,1,0-.16,0,0,0,0,1,0,0,0,0,0,0,1,0,0Z"
                            />
                            <path
                                class="cls-15"
                                d="M352.55,66.9a.16.16,0,0,1,0,0,.93.93,0,0,1,0-.1,1.6,1.6,0,0,1,.11-.3l.14-.31s0-.08.06-.1l0,0h0a.81.81,0,0,1,0,.16v.18a.68.68,0,0,1,0,.19.73.73,0,0,1-.16.33l-.09.09-.05,0a.06.06,0,0,1-.09,0,.08.08,0,0,1,0-.1"
                            />
                            <path
                                class="cls-27"
                                d="M348.19,66.41v0h0l0,0,.06,0a1.13,1.13,0,0,0,.35.16.25.25,0,0,0,.17,0,.13.13,0,0,0,.07,0,.17.17,0,0,0,.06-.06.83.83,0,0,0,.07-.13l0,0h0a.28.28,0,0,0,0,.06.17.17,0,0,1,0,.07.34.34,0,0,1,0,.1.56.56,0,0,1,0,.12.53.53,0,0,1-.1.12.51.51,0,0,1-.32.08.78.78,0,0,1-.48-.26.41.41,0,0,1-.05-.09.16.16,0,0,1,0-.09.23.23,0,0,1,0-.07h0a.07.07,0,0,1,.08,0,.07.07,0,0,1,.05,0Z"
                            />
                            <path
                                class="cls-15"
                                d="M344.48,59.47a4.86,4.86,0,0,1,.18,1.46c0,1.16-.73-.76-1-.86-.43.07,1-.69.78-.6"
                            />
                            <path
                                class="cls-15"
                                d="M341.58,60.42c0,.14.91.88.36.82-.6-.24-.69-.53-.86-.61s.69-.89.5-.21"
                            />
                            <path
                                class="cls-27"
                                d="M341,60.63a1,1,0,0,1,.32-.39,1.64,1.64,0,0,1,.42-.26,2.63,2.63,0,0,1,.95-.22,2.68,2.68,0,0,1,.49,0c.16,0,.32,0,.47,0a.52.52,0,0,0,.34-.06s.05-.07.08-.16a.83.83,0,0,1,.07-.13.6.6,0,0,1,.12-.11,4.64,4.64,0,0,1,.42-.25l.42-.22c.28-.15.56-.28.85-.42s.58-.26.87-.37l.46-.16.23-.06.13,0a.39.39,0,0,1,.14,0h0v0s0,.09.07.14l.08.13a.94.94,0,0,0,.09.12l.05.06.05,0,.25.19a1.43,1.43,0,0,0,.28.13h0a1.22,1.22,0,0,1-.57-.28l-.06-.05-.06,0a.69.69,0,0,1-.11-.13,1.47,1.47,0,0,1-.1-.13s-.05-.09-.08-.14l0,0a.51.51,0,0,0-.2,0l-.22.06-.43.18q-.42.2-.84.42l-.83.43-.41.23-.39.24a.27.27,0,0,0-.1.13.54.54,0,0,1-.13.25.47.47,0,0,1-.29.13h-.27a3.89,3.89,0,0,0-.47,0,3.38,3.38,0,0,0-.45,0,3.26,3.26,0,0,0-.89.16,1.53,1.53,0,0,0-.4.21,1.07,1.07,0,0,0-.3.3h0a.07.07,0,0,1-.09,0,.05.05,0,0,1,0-.08"
                            />
                            <path
                                class="cls-26"
                                d="M344.33,61l-.07-.15s-.05-.09-.07-.14l-.1-.17a2.61,2.61,0,0,0-.19-.3l-.07-.1,0,0h0l.13.11a.68.68,0,0,1,.12.12,1.58,1.58,0,0,1,.12.15,1.2,1.2,0,0,1,.17.34.65.65,0,0,1,0,.17,0,0,0,0,1,0,0,0,0,0,0,1,0,0Z"
                            />
                            <path d="M348.52,50.66a.32.32,0,1,1-.32-.33.32.32,0,0,1,.32.33" />
                            <path class="cls-15" d="M348.87,50.33a.24.24,0,0,1-.48,0,.24.24,0,0,1,.48,0" />
                            <path
                                d="M339.84,52.16a.11.11,0,0,1-.11.12.12.12,0,0,1-.12-.12.11.11,0,0,1,.12-.11.11.11,0,0,1,.11.11"
                            />
                            <path
                                class="cls-25"
                                d="M347,51l0,0,.05-.1a2.19,2.19,0,0,1,.24-.32,1.62,1.62,0,0,1,.18-.2l.24-.19.13-.08.14-.09a1.69,1.69,0,0,1,.31-.13l.16-.06.16,0a1.92,1.92,0,0,1,.32-.05,1.63,1.63,0,0,1,.31,0l.26,0,.23,0,.16.06.14.05,0,.11h-.31l-.21,0-.24,0a1.27,1.27,0,0,0-.26,0,2.76,2.76,0,0,0-.27.08l-.14,0-.14.06-.13.05-.13.07-.26.13-.22.14-.11.07-.1.06-.17.12-.13.1-.12.09Z"
                            />
                            <path class="cls-15" d="M340,52a.17.17,0,0,1-.34,0,.17.17,0,0,1,.34,0" />
                            <path
                                class="cls-25"
                                d="M339.07,51.75a1,1,0,0,1,.22-.06.77.77,0,0,1,.22,0l.26,0a1,1,0,0,1,.24.09l.11.05.09.07.07.06a.21.21,0,0,1,0,.06l0,.05,0,0-.05,0-.13-.07L340,52l-.23-.05-.45-.09-.21-.06"
                            />
                            <path class="cls-28" d="M337.53,58.48s-2-10,4.74-15.58,29.05-3.41,29.05-3.41" />
                            <path
                                class="cls-17"
                                d="M353.2,43a2.35,2.35,0,0,1,2.44.14,1.92,1.92,0,0,0,2.41-1c.33-.77.39-6-2.56-6.77-4.15-1.11-3.91-1.21-4.58,1.24a6.4,6.4,0,0,0,0,4c.36,1.42,1.05,2.83,2.3,2.35"
                            />
                            <path
                                class="cls-17"
                                d="M337.57,57.74c-.12-1.31,2.24-1.72,3.37-1.75,2.93-.06,1.85,1.19.74,2.41-.41.41-1,.76-.34,1.43h0s.1.19,0,.26c-2.81-.7-3.6-1-3.72-2.34"
                            />
                            <path
                                class="cls-25"
                                d="M341.14,57.87a1.92,1.92,0,0,0-.3.13l-.14.08a1.21,1.21,0,0,1-.14.1l-.15.12a1.66,1.66,0,0,1-.13.14l-.1.15a.79.79,0,0,0-.08.16.53.53,0,0,0,0,.16.38.38,0,0,0,0,.15.49.49,0,0,0,0,.12l0,.09,0,.08v0a.11.11,0,0,1-.09.13.1.1,0,0,1-.13-.08h0l0-.1v-.12a.71.71,0,0,1,0-.14.57.57,0,0,1,0-.18,1.27,1.27,0,0,1,.06-.18,1.63,1.63,0,0,1,.11-.17,1.07,1.07,0,0,1,.14-.16l.15-.13.16-.11.16-.09.15-.07a2.5,2.5,0,0,1,.31-.1h0"
                            />
                        </g>
                    </g>
                    <g class="cls-12">
                        <path
                            class="cls-13"
                            d="M363.9,54.84c4.48-3.42,6.82-10.67,7.63-15.39,1.69,10.61-8.8,27.1-14.06,28.92s-5.29,2-8.45,1.74c.29-.14-.06-.94.72-.63.24.1.65-.23,1-.36L350.5,69l.09-.15.28-.16h.19l.2-.48.14-.12.82-.17.15-.55,0,0,0,0,.59-.47.27-.61c.22-.12.44.55.65,0,0-.11,0-.22,0-.33.15-.13.38-.23.44-.39.47-1.46.46-1.46,1.3-1.24a.14.14,0,0,0,.11,0l.3-.45a4.06,4.06,0,0,0-.14.76c0,.12.16.25.25.37.3-.77,1.37-1,1.45-1.9l0,0c.88.43.69-.34.82-.75h.44a2.33,2.33,0,0,1,.17.26,3.71,3.71,0,0,1,.43-1,2.06,2.06,0,0,0,.41-1.58c.34.66.33-.13.52-.12l-.27-.55.62-.66c0-.09,0-.17,0-.25h0c0-.18,0-.36,0-.54l.1-.14.27-.12-.22-.24-.17-.32c-.25-.65,1.39-.49.6-1.38l-.11-.21c.54,0,.17-.4.21-.62l0-.23.07-.16a.11.11,0,0,1,.07-.06c1.12-.72,2.24.59,2.32.47"
                        />
                    </g>
                    <g class="cls-9">
                        <path class="cls-11" d="M371.47,39.65C373.24,66.51,355.92,73,355.92,73" />
                    </g>
                </g>
            </g>
            <path
                class="cls-15"
                d="M367.4,24.71a.51.51,0,0,1-.48.53q-10.8,0-21.59,0a.51.51,0,0,1-.48-.53c.09-10.29-.57-13.54.5-13.54,2.34,0,6.28,0,8.62,0a.64.64,0,0,0,.6-.66c0-2.57.09-6.89,0-9.51-.06-1.6,2-.76,11.62-.93.67,0,1.21.76,1.21,1.5C367.39,5.67,367.39,18.22,367.4,24.71Zm-6.26-13.55c1.56,0,3.12,0,4.68,0,.42,0,.65,0,.64-.61,0-2.63,0-5.25,0-7.88,0-.93-.19-1.12-1.12-1.12-3,0-5.93,0-8.89,0-.45,0-.64.07-.63.63,0,2.74,0,5.48,0,8.22,0,.75,0,.76.8.76Zm-4.38,1.37c-2.34,0-4.68,0-7,0-.66,0-1.08.17-1.19.93-.05.32,0,6.7,0,9.38,0,1.29.7,1.22,2.08,1.25,6.11.11,6.82.11,11.79,0,1.6,0,2.44-.33,2.45-1.82q0-4.11,0-8.22a1.33,1.33,0,0,0-1.41-1.52Zm-9.08,5.83V17c0-.46-.32-.38-.55-.34s-.37.21-.37.34c0,.79,0,1.59,0,2.38,0,.46.32.38.54.34a.54.54,0,0,0,.38-.34A6.92,6.92,0,0,0,347.68,18.36Z"
            />
            <path
                class="cls-15"
                d="M351.24,2.58a4.3,4.3,0,0,0,.62,0c.42,0,.53.14.52.58s-.14.51-.46.46a3,3,0,0,0-3.09,1.31c-.33.28-.35.84,0,.81,1.06-.08.15.77,0,1s-.47.58-.7.89c-.86,1.15-.87,1.15-1.43-.09-.17-.38-.28-.78-.45-1.16-.29-.68-.28-.78.36-.72s.64-.3.82-.69A3.79,3.79,0,0,1,351.24,2.58Z"
            />
            <path
                class="cls-15"
                d="M361,3.61H359.9c-.42,0-.36-.34-.32-.59s.19-.42.3-.42c.72,0,1.45,0,2.17,0,.42,0,.36.33.32.58s-.18.41-.3.43A7.93,7.93,0,0,1,361,3.61Z"
            />
            <path
                class="cls-15"
                d="M356.76,22.82h-6.25c-.41,0-.66,0-.66-.6,0-2.69,0-5.37,0-8.06,0-.57.21-.62.64-.62H363c.41,0,.66,0,.66.61,0,2.68,0,5.37,0,8.05,0,.58-.21.63-.64.62C360.92,22.81,358.84,22.82,356.76,22.82Z"
            />
            <circle class="cls-29" cx="23.04" cy="52.33" r="22.28" />
            <path
                d="M3.48,50a2.53,2.53,0,0,1,.19-1A2.17,2.17,0,0,1,5,47.76a2.69,2.69,0,0,1,1-.17,2.73,2.73,0,0,1,1,.17,2.27,2.27,0,0,1,.79.48,2.33,2.33,0,0,1,.52.77,2.71,2.71,0,0,1,.18,1,2.66,2.66,0,0,1-.18,1,2.33,2.33,0,0,1-.52.77,2.45,2.45,0,0,1-.79.49,3,3,0,0,1-1,.17,2.91,2.91,0,0,1-1-.17,2.35,2.35,0,0,1-.79-.49A2.18,2.18,0,0,1,3.67,51,2.48,2.48,0,0,1,3.48,50Zm1.06,0a1.63,1.63,0,0,0,.1.59,1.39,1.39,0,0,0,.29.47,1.21,1.21,0,0,0,.46.31,1.38,1.38,0,0,0,.59.12,1.41,1.41,0,0,0,.59-.12A1.1,1.1,0,0,0,7,51.08a1.13,1.13,0,0,0,.29-.47,1.66,1.66,0,0,0,0-1.19A1.2,1.2,0,0,0,7,49a1.1,1.1,0,0,0-.45-.31A1.41,1.41,0,0,0,6,48.53a1.38,1.38,0,0,0-.59.11,1.21,1.21,0,0,0-.46.31,1.49,1.49,0,0,0-.29.47A1.64,1.64,0,0,0,4.54,50Z"
            />
            <path
                d="M9.17,47.7h1.72a3,3,0,0,1,.68.07,1.64,1.64,0,0,1,.56.22,1.15,1.15,0,0,1,.37.44,1.37,1.37,0,0,1,.14.68,1.56,1.56,0,0,1-.13.68,1,1,0,0,1-.36.43,1.48,1.48,0,0,1-.54.24,3.55,3.55,0,0,1-.68.07h-.74v1.8h-1Zm1,2h.68l.26,0a.79.79,0,0,0,.23-.09.44.44,0,0,0,.16-.17.45.45,0,0,0,.07-.27.44.44,0,0,0-.09-.29.49.49,0,0,0-.21-.16.77.77,0,0,0-.28-.08l-.3,0h-.52Z"
            />
            <path
                d="M13.28,47.7H15a3,3,0,0,1,.68.07,1.56,1.56,0,0,1,.56.22,1.09,1.09,0,0,1,.38.44,1.49,1.49,0,0,1,.14.68,1.56,1.56,0,0,1-.13.68,1.09,1.09,0,0,1-.36.43,1.48,1.48,0,0,1-.54.24,3.64,3.64,0,0,1-.68.07H14.3v1.8h-1Zm1,2H15l.27,0a.92.92,0,0,0,.23-.09.52.52,0,0,0,.16-.17.54.54,0,0,0,.06-.27.5.5,0,0,0-.08-.29.49.49,0,0,0-.21-.16.83.83,0,0,0-.28-.08l-.3,0H14.3Z"
            />
            <path
                d="M17.15,50a2.53,2.53,0,0,1,.19-1,2.17,2.17,0,0,1,1.31-1.25,2.69,2.69,0,0,1,1-.17,2.73,2.73,0,0,1,1,.17,2.27,2.27,0,0,1,.79.48A2.18,2.18,0,0,1,22,49a2.71,2.71,0,0,1,.19,1A2.66,2.66,0,0,1,22,51a2.18,2.18,0,0,1-.52.77,2.45,2.45,0,0,1-.79.49,3,3,0,0,1-1,.17,2.91,2.91,0,0,1-1-.17,2.35,2.35,0,0,1-.79-.49,2.18,2.18,0,0,1-.52-.77A2.48,2.48,0,0,1,17.15,50Zm1.06,0a1.87,1.87,0,0,0,.1.59,1.39,1.39,0,0,0,.29.47,1.21,1.21,0,0,0,.46.31,1.38,1.38,0,0,0,.59.12,1.41,1.41,0,0,0,.59-.12,1.21,1.21,0,0,0,.46-.31,1.39,1.39,0,0,0,.29-.47,1.82,1.82,0,0,0,0-1.19A1.49,1.49,0,0,0,20.7,49a1.21,1.21,0,0,0-.46-.31,1.41,1.41,0,0,0-.59-.11,1.38,1.38,0,0,0-.59.11,1.21,1.21,0,0,0-.46.31,1.49,1.49,0,0,0-.29.47A1.89,1.89,0,0,0,18.21,50Z"
            />
            <path d="M22.84,47.7h1.38l2,3.22h0V47.7h1v4.63H25.89l-2-3.29h0v3.29h-1Z" />
            <path d="M28.2,47.7h3.15v.94H29.22v.87h2v.94h-2v.94h2.24v.94H28.2Z" />
            <path d="M32.28,47.7h1.39l2,3.22h0V47.7h1v4.63H35.33l-2-3.29h0v3.29h-1Z" />
            <path d="M38.5,48.6H37.18v-.9h3.66v.9H39.52v3.73h-1Z" />
            <path d="M13.82,55.54h1v3.69h1.89v.94H13.82Z" />
            <path
                d="M17,57.86a2.71,2.71,0,0,1,.18-1,2.43,2.43,0,0,1,.52-.77,2.31,2.31,0,0,1,.8-.48,2.66,2.66,0,0,1,1-.17,2.73,2.73,0,0,1,1,.17,2.36,2.36,0,0,1,.79.48,2.25,2.25,0,0,1,.51.77,2.53,2.53,0,0,1,.19,1,2.48,2.48,0,0,1-.19,1,2.16,2.16,0,0,1-.51.77,2.39,2.39,0,0,1-.79.49,3,3,0,0,1-1,.17,2.87,2.87,0,0,1-1-.17,2.2,2.2,0,0,1-1.32-1.26A2.66,2.66,0,0,1,17,57.86Zm1.06,0a1.68,1.68,0,0,0,.1.6,1.42,1.42,0,0,0,.29.47,1.57,1.57,0,0,0,.45.31,1.66,1.66,0,0,0,1.19,0,1.57,1.57,0,0,0,.45-.31,1.42,1.42,0,0,0,.29-.47,1.85,1.85,0,0,0,0-1.2,1.33,1.33,0,0,0-.29-.47,1.39,1.39,0,0,0-.45-.31,1.44,1.44,0,0,0-.59-.11,1.46,1.46,0,0,0-.6.11,1.39,1.39,0,0,0-.45.31,1.33,1.33,0,0,0-.29.47A1.68,1.68,0,0,0,18.1,57.86Z"
            />
            <path
                d="M26.91,59.84a3.53,3.53,0,0,1-.94.34,4.71,4.71,0,0,1-1,.11,3,3,0,0,1-1-.17,2.29,2.29,0,0,1-.79-.49,2.33,2.33,0,0,1-.52-.77,2.66,2.66,0,0,1-.18-1,2.71,2.71,0,0,1,.18-1,2.43,2.43,0,0,1,.52-.77A2.27,2.27,0,0,1,24,55.6a2.73,2.73,0,0,1,1-.17,3.77,3.77,0,0,1,1,.13,2,2,0,0,1,.82.46l-.72.79a1.34,1.34,0,0,0-.47-.33,1.63,1.63,0,0,0-.66-.11,1.41,1.41,0,0,0-.59.11,1.29,1.29,0,0,0-.45.31,1.2,1.2,0,0,0-.29.47,1.85,1.85,0,0,0,0,1.2,1.28,1.28,0,0,0,.29.47,1.44,1.44,0,0,0,.45.31,1.59,1.59,0,0,0,.59.11,2,2,0,0,0,.58-.08,2.14,2.14,0,0,0,.38-.15v-.75H25.1v-.94h1.81Z"
            />
            <path
                d="M27.56,57.86a2.53,2.53,0,0,1,.19-1,2.14,2.14,0,0,1,.52-.77,2.18,2.18,0,0,1,.79-.48,2.66,2.66,0,0,1,1-.17,2.73,2.73,0,0,1,1,.17,2.27,2.27,0,0,1,.79.48,2.43,2.43,0,0,1,.52.77,2.71,2.71,0,0,1,.18,1,2.66,2.66,0,0,1-.18,1,2.33,2.33,0,0,1-.52.77,2.29,2.29,0,0,1-.79.49,3,3,0,0,1-1,.17,2.87,2.87,0,0,1-1-.17,2.2,2.2,0,0,1-.79-.49,2.06,2.06,0,0,1-.52-.77A2.48,2.48,0,0,1,27.56,57.86Zm1.06,0a1.68,1.68,0,0,0,.1.6,1.42,1.42,0,0,0,.29.47,1.57,1.57,0,0,0,.45.31,1.66,1.66,0,0,0,1.19,0,1.44,1.44,0,0,0,.45-.31,1.28,1.28,0,0,0,.29-.47,1.85,1.85,0,0,0,0-1.2,1.2,1.2,0,0,0-.29-.47,1.29,1.29,0,0,0-.45-.31,1.44,1.44,0,0,0-.59-.11,1.46,1.46,0,0,0-.6.11,1.39,1.39,0,0,0-.45.31,1.33,1.33,0,0,0-.29.47A1.68,1.68,0,0,0,28.62,57.86Z"
            />
        </g>
    </g>
</svg>

<!-- <svg id="event-top-text-icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 372.05 154.66">
    <defs>
        <clipPath id="clip-path">
            <rect class="cls-1" x="337.01" y="31.16" width="35.04" height="42.35" />
        </clipPath>
        <clipPath id="clip-path-3">
            <path class="cls-1" d="M354.92,31.16c-9.08,0-16.86,3.26-17.11,3.94-1.23,22.12,7.86,34.16,16.9,36.23,0,0,18.66-7,16.75-36A33.79,33.79,0,0,0,354.92,31.16Z" />
        </clipPath>
        <clipPath id="clip-path-5">
            <rect class="cls-1" x="337.01" y="34.65" width="34.53" height="35.54" />
        </clipPath>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
            <polygon class="cls-2" points="10.38 5.42 8.58 3.65 0 12.04 8.58 20.43 10.38 18.66 3.62 12.04 10.38 5.42" />
            <text class="cls-3" transform="translate(156.93 18.02)">1/29/21</text>
            <text class="cls-3" transform="translate(255.93 148.08)">TWITTER</text>
            <text class="cls-4" transform="translate(318.4 118.04)">
                <tspan class="cls-5">A</tspan>
                <tspan x="7.68" y="0">TU</tspan>
            </text>
            <text class="cls-4" transform="translate(22.37 118.04)">Lions</text>
            <text class="cls-3" transform="translate(36.35 148.08)">
                EVEN
                <tspan class="cls-6" x="41.14" y="0">T</tspan>
                <tspan x="49.87" y="0" xml:space="preserve">INFO</tspan>
            </text>
            <text class="cls-4" transform="translate(278.72 16.84)">
                player st
                <tspan class="cls-7" x="46.22" y="0">a</tspan>
                <tspan class="cls-8" x="52.51" y="0">ts</tspan>
            </text>
            <g id="Artwork_1" data-name="Artwork 1">
                <g class="cls-9">
                    <g class="cls-9">
                        <path class="cls-10" d="M356.11,35.74a31.43,31.43,0,0,1,15.36,3.91C373.24,66.51,355.92,73,355.92,73c-8.4-1.92-16.83-13.1-15.69-33.63.23-.64,7.46-3.65,15.88-3.66" />
                        <path class="cls-11" d="M356.11,35.74a31.43,31.43,0,0,1,15.36,3.91C373.24,66.51,355.92,73,355.92,73c-8.4-1.92-16.83-13.1-15.69-33.63C340.46,38.76,347.69,35.75,356.11,35.74Z" />
                        <path d="M348.12,67.45a14.32,14.32,0,0,0,7.76,5.11s17.36-6,15.59-32.91Z" />
                    </g>
                    <g class="cls-12">
                        <path class="cls-13" d="M363.9,54.84c4.48-3.42,6.82-10.67,7.63-15.39,1.69,10.61-8.8,27.1-14.06,28.92s-5.29,2-8.45,1.74c.29-.14-.06-.94.72-.63.24.1.65-.23,1-.36L350.5,69l.09-.15.28-.16h.19l.2-.48.14-.12.82-.17.15-.55,0,0,0,0,.59-.47.27-.61c.22-.12.44.55.65,0,0-.11,0-.22,0-.33.15-.13.38-.23.44-.39.47-1.46.46-1.46,1.3-1.24a.14.14,0,0,0,.11,0l.3-.45a4.06,4.06,0,0,0-.14.76c0,.12.16.25.25.37.3-.77,1.37-1,1.45-1.9l0,0c.88.43.69-.34.82-.75h.44a2.33,2.33,0,0,1,.17.26,3.71,3.71,0,0,1,.43-1,2.06,2.06,0,0,0,.41-1.58c.34.66.33-.13.52-.12l-.27-.55.62-.66c0-.09,0-.17,0-.25h0c0-.18,0-.36,0-.54l.1-.14.27-.12-.22-.24-.17-.32c-.25-.65,1.39-.49.6-1.38l-.11-.21c.54,0,.17-.4.21-.62l0-.23.07-.16a.11.11,0,0,1,.07-.06c1.12-.72,2.24.59,2.32.47" />
                    </g>
                    <g class="cls-9">
                        <g class="cls-14">
                            <path class="cls-15" d="M345.55,63.88l-4.37-2.12-3.48-2.38-.17-.9s-2-10,4.74-15.58,29.05-3.41,29.05-3.41.5,9.15-4.44,16.5S359,66,359,66l-5.9,2.66-4.4.52L346.25,67c-.14,0-.36.26-.46.35s-.24.07-.2-.06Z" />
                            <path class="cls-16" d="M362,54.23s-1.33.27-1.41,1.42-2,3.4-2.77,3.8a10,10,0,0,1-4.67.65c-1.33-.27-1.16-2.32-1.58-2.71s1.25-3.47-.35-1.4a4,4,0,0,1-3.39,1.85l2.72,8.88L348,68.24l.37.36-.38.15c-.44-.3-.95.42-1.38.12l-.35-.08c.27.8,1.05.93,1.69,1.23l1.09.17.71-.45h0l3.55-1.66,4.45-2.71,3.89-7.59Z" />
                            <path class="cls-17" d="M352.19,50.34a19.33,19.33,0,0,0,.05,3.52c0,1.19-.93,1.17-1.74,1.3-2.69-.09-3.81-2.57-5.56-4-.76-.62.6-2.34,1.42-3.34s1.95-.92,3-.1,1.89,2,2.67,2,.41.29.2.63" />
                            <path class="cls-18" d="M340.84,44.42a30.43,30.43,0,0,0-2.23,3.07,5.13,5.13,0,0,1-.55-1.45,20.18,20.18,0,0,1,0-3c.05-.65.57-.29.79-.16.61.36,2.46,1,2,1.55" />
                            <path class="cls-18" d="M340.93,52l-1.71,2.08a5.45,5.45,0,0,1-.54-2.13,11.56,11.56,0,0,1,1.15-2.64c1.1.52.59,1.64,1.1,2.69" />
                            <path class="cls-19" d="M346.66,58.31l-.31,0,.31,0" />
                            <path class="cls-20" d="M337,57s0,0,0,0h0s0,0,0,0" />
                            <path class="cls-21" d="M350.28,54.23l0,0,0,0h0" />
                            <path class="cls-22" d="M350.84,68.67l.21-.48-.21.48" />
                            <path class="cls-22" d="M350.38,68.84l.27-.16-.27.16" />
                            <path class="cls-19" d="M344.25,59.45l.48-.15-.48.15" />
                            <path class="cls-17" d="M350.19,60.2s-.08,0-.08,0,0,0,0-.08.07,0,.08,0,0,.05,0,.08" />
                            <polyline class="cls-23" points="340.72 60.2 340.72 60.19 340.72 60.2" />
                            <path class="cls-16" d="M339.28,59.67l0,.13-.09-.13h.13" />
                            <path class="cls-16" d="M353.4,64.7c.05.06.12.1.12.14s-.06.08-.09.12-.08-.07-.08-.1,0-.09,0-.16" />
                            <path class="cls-16" d="M352.88,64.33c.07-.11.15-.22.22-.34l-.1.34h-.12" />
                            <path class="cls-16" d="M352.77,64.58v0" />
                            <path class="cls-24" d="M343,63.88l.06.22Z" />
                            <path class="cls-24" d="M342.78,61l-.59-.34s-.24,0-.27-.06a1.33,1.33,0,0,1-.3-.07l-.56.23c-.11-.05-.32-.22-.28-.33l.11-.23-.49,0-.15,0-1-.52-.38-.18-1.37-1.53c-.64.32.08,2.21,1.16,3.07.53.49,5.74,3.8,5.71,3.72l.08.26v-.77Z" />
                            <path class="cls-18" d="M350.62,60.45c0-.22-.09-.8-.09-.88-.46,0-1,0-1-.68-.63-.14-1.42-.26-1.7-1-.41.12-1.33.44-1.43.45s-.51.58-.6.71c-.16.34-.51,0-.51,0l-.23,0c-.18.1-.26.1-.44.2s-.16.15-.32.2c-.06.27-.55.51-.72.41-.37,0-.72.08-1.09.08L342,60c-.29,0-.77.37-.14.73,1.23.4.92,1.57,1,2.5a2.38,2.38,0,0,1,1.59,1.72c1.1.79.25,2.12.85,3,.32.28.81.75,1,.84.42.51,3.3-.31,3.59-.83a6.34,6.34,0,0,0,1.19-2.26,10.34,10.34,0,0,0-.46-5.25" />
                            <path class="cls-25" d="M349.07,50.62a.75.75,0,1,1-1.5,0,.75.75,0,0,1,1.5,0" />
                            <path class="cls-25" d="M340.12,52.14a.34.34,0,0,1-.67,0,.34.34,0,1,1,.67,0" />
                            <path class="cls-15" d="M350.36,66.81c-.25.41-2.47,1-2.78,1.11a5.12,5.12,0,0,1-1.11.18,1.18,1.18,0,0,1-.92-1.08c0-1.21.25-.07.67,0,.5-.14,1.26-.38,1.9-.58a2.1,2.1,0,0,1-.1-1.06c.13-.22.64.41.93.81,1.14-.34,1.51-.5,1.7-.28s0,.52-.29.93" />
                            <path class="cls-15" d="M357.1,63.46l0,0-.09.11-.27.32-.29.33-.11.11,0,0h0a.18.18,0,0,1,0,0,.55.55,0,0,1,0-.16l0-.09.05-.11a.54.54,0,0,1,.05-.11l.07-.11a1,1,0,0,1,.33-.34.37.37,0,0,1,.14-.07l.07,0a.07.07,0,0,1,.09,0s0,.08,0,.09" />
                            <path class="cls-15" d="M359.76,60.43l0,.06-.09.18a.67.67,0,0,1-.06.12l-.06.13-.07.14-.07.15-.25.57L359,62l0,.08h0v-.3s0-.09,0-.14l0-.16c0-.05,0-.11,0-.17s0-.11.05-.16a.87.87,0,0,1,.07-.17,1.11,1.11,0,0,1,.07-.16l.09-.13a.62.62,0,0,1,.09-.12,1.2,1.2,0,0,1,.15-.16l.07-.05a.07.07,0,1,1,.1.1" />
                            <path class="cls-15" d="M353.65,65.7l0,0,.08-.12.26-.34.27-.34.1-.12,0,0h0v.06a1.43,1.43,0,0,1,0,.16l0,.1,0,.11a1.17,1.17,0,0,0-.05.11l-.06.11a1.24,1.24,0,0,1-.31.36l-.14.08-.07,0a.07.07,0,1,1-.07-.11" />
                            <path class="cls-26" d="M348.12,65.47l0,.14,0,.15,0,.16c0,.12.06.23.08.32l0,.1v0h0l-.09-.12-.07-.14-.06-.17a1.06,1.06,0,0,1,0-.33.39.39,0,0,1,0-.16,0,0,0,0,1,0,0,0,0,0,0,1,0,0Z" />
                            <path class="cls-15" d="M352.55,66.9a.16.16,0,0,1,0,0,.93.93,0,0,1,0-.1,1.6,1.6,0,0,1,.11-.3l.14-.31s0-.08.06-.1l0,0h0a.81.81,0,0,1,0,.16v.18a.68.68,0,0,1,0,.19.73.73,0,0,1-.16.33l-.09.09-.05,0a.06.06,0,0,1-.09,0,.08.08,0,0,1,0-.1" />
                            <path class="cls-27" d="M348.19,66.41v0h0l0,0,.06,0a1.13,1.13,0,0,0,.35.16.25.25,0,0,0,.17,0,.13.13,0,0,0,.07,0,.17.17,0,0,0,.06-.06.83.83,0,0,0,.07-.13l0,0h0a.28.28,0,0,0,0,.06.17.17,0,0,1,0,.07.34.34,0,0,1,0,.1.56.56,0,0,1,0,.12.53.53,0,0,1-.1.12.51.51,0,0,1-.32.08.78.78,0,0,1-.48-.26.41.41,0,0,1-.05-.09.16.16,0,0,1,0-.09.23.23,0,0,1,0-.07h0a.07.07,0,0,1,.08,0,.07.07,0,0,1,.05,0Z" />
                            <path class="cls-15" d="M344.48,59.47a4.86,4.86,0,0,1,.18,1.46c0,1.16-.73-.76-1-.86-.43.07,1-.69.78-.6" />
                            <path class="cls-15" d="M341.58,60.42c0,.14.91.88.36.82-.6-.24-.69-.53-.86-.61s.69-.89.5-.21" />
                            <path class="cls-27" d="M341,60.63a1,1,0,0,1,.32-.39,1.64,1.64,0,0,1,.42-.26,2.63,2.63,0,0,1,.95-.22,2.68,2.68,0,0,1,.49,0c.16,0,.32,0,.47,0a.52.52,0,0,0,.34-.06s.05-.07.08-.16a.83.83,0,0,1,.07-.13.6.6,0,0,1,.12-.11,4.64,4.64,0,0,1,.42-.25l.42-.22c.28-.15.56-.28.85-.42s.58-.26.87-.37l.46-.16.23-.06.13,0a.39.39,0,0,1,.14,0h0v0s0,.09.07.14l.08.13a.94.94,0,0,0,.09.12l.05.06.05,0,.25.19a1.43,1.43,0,0,0,.28.13h0a1.22,1.22,0,0,1-.57-.28l-.06-.05-.06,0a.69.69,0,0,1-.11-.13,1.47,1.47,0,0,1-.1-.13s-.05-.09-.08-.14l0,0a.51.51,0,0,0-.2,0l-.22.06-.43.18q-.42.2-.84.42l-.83.43-.41.23-.39.24a.27.27,0,0,0-.1.13.54.54,0,0,1-.13.25.47.47,0,0,1-.29.13h-.27a3.89,3.89,0,0,0-.47,0,3.38,3.38,0,0,0-.45,0,3.26,3.26,0,0,0-.89.16,1.53,1.53,0,0,0-.4.21,1.07,1.07,0,0,0-.3.3h0a.07.07,0,0,1-.09,0,.05.05,0,0,1,0-.08" />
                            <path class="cls-26" d="M344.33,61l-.07-.15s-.05-.09-.07-.14l-.1-.17a2.61,2.61,0,0,0-.19-.3l-.07-.1,0,0h0l.13.11a.68.68,0,0,1,.12.12,1.58,1.58,0,0,1,.12.15,1.2,1.2,0,0,1,.17.34.65.65,0,0,1,0,.17,0,0,0,0,1,0,0,0,0,0,0,1,0,0Z" />
                            <path d="M348.52,50.66a.32.32,0,1,1-.32-.33.32.32,0,0,1,.32.33" />
                            <path class="cls-15" d="M348.87,50.33a.24.24,0,0,1-.48,0,.24.24,0,0,1,.48,0" />
                            <path d="M339.84,52.16a.11.11,0,0,1-.11.12.12.12,0,0,1-.12-.12.11.11,0,0,1,.12-.11.11.11,0,0,1,.11.11" />
                            <path class="cls-25" d="M347,51l0,0,.05-.1a2.19,2.19,0,0,1,.24-.32,1.62,1.62,0,0,1,.18-.2l.24-.19.13-.08.14-.09a1.69,1.69,0,0,1,.31-.13l.16-.06.16,0a1.92,1.92,0,0,1,.32-.05,1.63,1.63,0,0,1,.31,0l.26,0,.23,0,.16.06.14.05,0,.11h-.31l-.21,0-.24,0a1.27,1.27,0,0,0-.26,0,2.76,2.76,0,0,0-.27.08l-.14,0-.14.06-.13.05-.13.07-.26.13-.22.14-.11.07-.1.06-.17.12-.13.1-.12.09Z" />
                            <path class="cls-15" d="M340,52a.17.17,0,0,1-.34,0,.17.17,0,0,1,.34,0" />
                            <path class="cls-25" d="M339.07,51.75a1,1,0,0,1,.22-.06.77.77,0,0,1,.22,0l.26,0a1,1,0,0,1,.24.09l.11.05.09.07.07.06a.21.21,0,0,1,0,.06l0,.05,0,0-.05,0-.13-.07L340,52l-.23-.05-.45-.09-.21-.06" />
                            <path class="cls-28" d="M337.53,58.48s-2-10,4.74-15.58,29.05-3.41,29.05-3.41" />
                            <path class="cls-17" d="M353.2,43a2.35,2.35,0,0,1,2.44.14,1.92,1.92,0,0,0,2.41-1c.33-.77.39-6-2.56-6.77-4.15-1.11-3.91-1.21-4.58,1.24a6.4,6.4,0,0,0,0,4c.36,1.42,1.05,2.83,2.3,2.35" />
                            <path class="cls-17" d="M337.57,57.74c-.12-1.31,2.24-1.72,3.37-1.75,2.93-.06,1.85,1.19.74,2.41-.41.41-1,.76-.34,1.43h0s.1.19,0,.26c-2.81-.7-3.6-1-3.72-2.34" />
                            <path class="cls-25" d="M341.14,57.87a1.92,1.92,0,0,0-.3.13l-.14.08a1.21,1.21,0,0,1-.14.1l-.15.12a1.66,1.66,0,0,1-.13.14l-.1.15a.79.79,0,0,0-.08.16.53.53,0,0,0,0,.16.38.38,0,0,0,0,.15.49.49,0,0,0,0,.12l0,.09,0,.08v0a.11.11,0,0,1-.09.13.1.1,0,0,1-.13-.08h0l0-.1v-.12a.71.71,0,0,1,0-.14.57.57,0,0,1,0-.18,1.27,1.27,0,0,1,.06-.18,1.63,1.63,0,0,1,.11-.17,1.07,1.07,0,0,1,.14-.16l.15-.13.16-.11.16-.09.15-.07a2.5,2.5,0,0,1,.31-.1h0" />
                        </g>
                    </g>
                    <g class="cls-12">
                        <path class="cls-13" d="M363.9,54.84c4.48-3.42,6.82-10.67,7.63-15.39,1.69,10.61-8.8,27.1-14.06,28.92s-5.29,2-8.45,1.74c.29-.14-.06-.94.72-.63.24.1.65-.23,1-.36L350.5,69l.09-.15.28-.16h.19l.2-.48.14-.12.82-.17.15-.55,0,0,0,0,.59-.47.27-.61c.22-.12.44.55.65,0,0-.11,0-.22,0-.33.15-.13.38-.23.44-.39.47-1.46.46-1.46,1.3-1.24a.14.14,0,0,0,.11,0l.3-.45a4.06,4.06,0,0,0-.14.76c0,.12.16.25.25.37.3-.77,1.37-1,1.45-1.9l0,0c.88.43.69-.34.82-.75h.44a2.33,2.33,0,0,1,.17.26,3.71,3.71,0,0,1,.43-1,2.06,2.06,0,0,0,.41-1.58c.34.66.33-.13.52-.12l-.27-.55.62-.66c0-.09,0-.17,0-.25h0c0-.18,0-.36,0-.54l.1-.14.27-.12-.22-.24-.17-.32c-.25-.65,1.39-.49.6-1.38l-.11-.21c.54,0,.17-.4.21-.62l0-.23.07-.16a.11.11,0,0,1,.07-.06c1.12-.72,2.24.59,2.32.47" />
                    </g>
                    <g class="cls-9">
                        <path class="cls-11" d="M371.47,39.65C373.24,66.51,355.92,73,355.92,73" />
                    </g>
                </g>
            </g>
            <path class="cls-29" d="M20.65,73.5c-.08,0-.18,0-.81-.35-.41-.22-1-.54-1.58-.93-1.12-.69-3-1.89-5.57-3.7C9.07,66,8.22,63.93,8,63a3.32,3.32,0,0,1-.91.1,12.67,12.67,0,0,1-2.24-.26L3.64,62.6l1.14-.35a6.2,6.2,0,0,0,.72-1.81c.27-.95-.32-2.75-.9-4.48A17.65,17.65,0,0,1,3.52,51.5,5.54,5.54,0,0,1,4.64,48a7.9,7.9,0,0,1,.52-.64A2.77,2.77,0,0,1,3.94,47l-.33-.22.28-.29a24.29,24.29,0,0,0,2.72-3.27,3.93,3.93,0,0,1,2.55-1.74,2.09,2.09,0,0,1,0-1.35,3,3,0,0,1,.44-.82l.17-.21.24.12a6.6,6.6,0,0,0,1.29.54h0c.18,0,.6-.43,1-.81l.29-.3-.25-6.51a1.33,1.33,0,0,1-1-1.29,1.32,1.32,0,0,1,2.63,0,1.3,1.3,0,0,1-.27.79L18.06,36l1.41-4.57a1.3,1.3,0,0,1-.62-1.12,1.31,1.31,0,1,1,2.06,1.08l1.79,4.77,3.54-4.56a1.35,1.35,0,0,1-.19-.69,1.31,1.31,0,1,1,1.59,1.29l-.19,6a18.12,18.12,0,0,1,1.63,1.52l.14.14,0,0a.59.59,0,0,0,.23-.27l.17-.32.3.19A2.69,2.69,0,0,1,31,41.71a5.79,5.79,0,0,1,2.33,1.08,9.78,9.78,0,0,1,1.89,1.91,13.29,13.29,0,0,1,1.55,2.59l.22.49-1.45-.1a4.76,4.76,0,0,1,.9,1.69,8.72,8.72,0,0,1,.36,2.68A24.93,24.93,0,0,1,35,57.4c-.26.63-.48,1.18-.59,1.51-.31.89.42,2.67.73,3.28l.16.31-.32.14a5.19,5.19,0,0,1-2,.43h0a4,4,0,0,1-.77-.07,8,8,0,0,1-2.32,4,15.11,15.11,0,0,1-2.12,1.84l-.46-.44.2-.3-2.46,2a53.59,53.59,0,0,1-4.29,3.39A.23.23,0,0,1,20.65,73.5Z" />
            <circle cx="20.16" cy="30.29" r="0.99" />
            <circle cx="27.36" cy="30.89" r="0.99" />
            <circle cx="12.63" cy="30.89" r="0.99" />
            <polygon points="12.95 39.15 12.63 31.11 18.22 36.59 20.16 30.29 22.6 36.81 27.36 30.68 27.12 38.37 12.95 39.15" />
            <path d="M6,47a5.89,5.89,0,0,0-2.2,4.49c.1,2.77,2.53,7.12,2,9s-.87,2-.87,2,2.65.57,3.35,0c0,0-.14,2.39,4.59,5.72s7.63,5,7.77,4.91,8.29-6.65,8.29-6.65l-1.36,2.07s4.08-2.81,4.36-6a4.16,4.16,0,0,0,2.95-.25S33.72,60,34.14,58.8s2.29-5.38,2.34-6.77-.33-3.86-1.92-4.75l1.92.14S34.37,42.5,30.67,42a2.54,2.54,0,0,0-.89-2.2s-.37.75-.79.32-2.55-2.76-4.18-2.85-3.62,1.36-5.08.75-3.63-1.5-5.31-.42-2.52,2.71-3.18,2.52a7.88,7.88,0,0,1-1.36-.56,2.07,2.07,0,0,0-.23,2.25,3.43,3.43,0,0,0-2.76,1.64,25.47,25.47,0,0,1-2.77,3.32A2.79,2.79,0,0,0,6,47Z" />
            <path class="cls-30" d="M33.28,59.64,34,61.88s-2.23.38-3-.74c.08.13.93,1.55-1.31,3.63-1.72,1.58-6,4.74-8.24,6.35l-.19.13-1.17.84s-7.25-5.15-9.6-7.32-1.39-3.5-1.32-3.63c-.76,1.12-3,.74-3,.74L7,59.64c.75-2.25-.66-6-.66-6l.19,4S3.7,52.15,4.83,49.8a11.51,11.51,0,0,1,3.65-4l-3.09.31a28.18,28.18,0,0,0,2.25-2.51c.84-1.12,3.14-1.4,3.14-1.4-1.16-.28-.25-1.5-.25-1.5,1,1,3.85-3.75,6.56-2.81a5,5,0,0,1,.77.35,6.93,6.93,0,0,0,4.82-.15,4.53,4.53,0,0,1,.49-.2c2.71-.94,5.53,3.84,6.56,2.81,0,0,.9,1.22-.26,1.5,0,0,2.31.28,3.15,1.4a26.58,26.58,0,0,0,2.25,2.51l-3.09-.31a11.51,11.51,0,0,1,3.65,4c1.12,2.35-1.68,7.82-1.68,7.82l.18-4S32.53,57.39,33.28,59.64Z" />
            <path class="cls-31" d="M7,59.64l-.75,2.24s2.22.38,3-.74c-.07.13-.92,1.55,1.32,3.63,1.71,1.58,6,4.74,8.24,6.35l-4.11-5,3,2.88-1.42-3.58L19,68.94l-1.36-3.51,2.05,3.14,2-3.14L21.43,67s3.05-2.5,3.62-3.56L24.69,65s1.84-1.91,1.89-3.61,0-4.62,0-4.62L23.9,55l-3.25-9A5.57,5.57,0,0,0,16.83,43s1.38-.29,3.3,1.31a6.77,6.77,0,0,0-3-3.18l1.87.37s-1.51-2.81-3.56-2.25-4.22,3.24-4.92,1.5c0,0-.91,1.22.25,1.5,0,0-2.3.28-3.14,1.4a28.18,28.18,0,0,1-2.25,2.51l3.09-.31a11.51,11.51,0,0,0-3.65,4c-1.13,2.35,1.68,7.82,1.68,7.82l-.19-4S7.73,57.39,7,59.64Z" />
            <path d="M33.28,59.64,34,61.88s-2.23.38-3-.74c.08.13.93,1.55-1.31,3.63-1.72,1.58-6,4.74-8.24,6.35l4.1-5L22.6,69,24,65.43l-2.79,3.51,1.36-3.51-2,3.14-2-3.14L18.82,67s-3-2.5-3.62-3.56L15.56,65s-1.83-1.91-1.88-3.61,0-4.62,0-4.62L16.36,55l3.25-9A5.54,5.54,0,0,1,23.43,43s-1.38-.29-3.3,1.31a6.72,6.72,0,0,1,3-3.18l-1.87.37s1.52-2.81,3.57-2.25,4.22,3.24,4.92,1.5c0,0,.9,1.22-.26,1.5,0,0,2.31.28,3.15,1.4a26.58,26.58,0,0,0,2.25,2.51l-3.09-.31a11.51,11.51,0,0,1,3.65,4c1.12,2.35-1.68,7.82-1.68,7.82l.18-4S32.53,57.39,33.28,59.64Z" />
            <polygon class="cls-30" points="10.78 51.2 11.86 53.33 14.06 55.97 14.1 56.78 13.81 57.48 14.88 61.82 19.22 59.25 19.22 56.16 19.62 55.17 19.62 46.04 12.9 45.29 10.78 51.2" />
            <polygon class="cls-31" points="18.82 56.47 16.63 56.07 15.4 57 17.11 56.78 15.56 57.86 16.83 57.86 15.56 59.25 16.36 58.72 15.96 59.65 17.4 59.25 16.46 60.03 18.82 58.96 15.2 61.4 14.1 56.78 16.36 55 16.9 55.1 18.82 56.47" />
            <polygon class="cls-31" points="12.09 48 11.69 50.86 12.09 50.29 12.25 52.26 13.78 54.37 13.31 53.33 14.83 54.75 16.12 54.37 14.88 55.25 16.83 54.37 14.58 56.07 13.64 55.46 10.53 51.2 12.09 48" />
            <polygon points="16.36 49.87 17.78 55.17 19.62 55.17 19.62 56 19.62 56.78 16.97 55.77 16.36 49.87" />
            <path d="M16.36,49.87l-3.17-.49a2.17,2.17,0,0,0,3.27,1.48" />
            <path class="cls-15" d="M13.64,49.66l2.48.47a1.09,1.09,0,0,1-.62.69C15.05,50.94,14.36,50.85,13.64,49.66Z" />
            <polygon points="16.83 54.37 13.64 56.78 14.88 61.82 19.62 59.25 19.62 58.55 15.32 60.79 14.54 57.09 14.43 58.1 14.1 56.78 15.29 55.97 14.88 56.78 16.36 55.83 16.63 55.03 16.71 55.75 16.9 55.1 16.83 54.37" />
            <path d="M14.58,56.07S11.23,53,11.23,50.86l1.67-5.57,6.72.75L12.68,44.5l-2.12,6-1.34-.28,1.23,1.22,3.65,5.3Z" />
            <polygon points="19.62 56.78 19.62 59.25 18.82 59.25 18.82 56.47 19.62 56.78" />
            <polygon class="cls-30" points="28.45 51.2 27.37 53.33 25.17 55.97 25.14 56.78 25.42 57.48 24.35 61.82 20.01 59.25 20.01 56.16 19.61 55.17 19.61 46.04 26.33 45.29 28.45 51.2" />
            <polygon class="cls-31" points="22.26 55.77 20.71 57.03 20.71 58.41 22.14 59.25 21.24 59.06 23.3 59.97 23.77 57.87 23.77 59.65 24.03 57.25 22.87 56.25 23.94 56.78 23.11 55.22 25.59 56.78 24.03 61.4 19.73 58.91 19.73 56.28 22.26 55.77" />
            <polygon class="cls-31" points="22.87 49.87 25.59 48.15 23.5 47.49 25.38 47.49 24.03 46.84 25.86 45.83 22.77 46.45 23.83 45.83 20.61 46.42 21.24 46.04 19.61 46.04 26.48 44.98 28.26 50.13 28.17 51.82 25.17 55.97 24.66 56.07 22.4 54.37 22.87 49.87" />
            <polygon points="22.87 49.87 21.45 55.17 19.61 55.17 19.61 56 19.61 56.78 22.26 55.77 22.87 49.87" />
            <path d="M22.87,49.87,26,49.38a2.17,2.17,0,0,1-3.27,1.48Z" />
            <path class="cls-15" d="M25.59,49.66l-2.48.47a1.13,1.13,0,0,0,.62.69C24.18,50.94,24.87,50.85,25.59,49.66Z" />
            <polygon points="22.4 54.37 25.59 56.78 24.35 61.82 19.61 59.25 19.61 58.55 23.91 60.79 24.69 57.09 24.8 58.1 25.14 56.78 23.94 55.97 24.35 56.78 22.87 55.83 22.6 55.03 22.52 55.75 22.33 55.1 22.4 54.37" />
            <path d="M24.66,56.07S28,53,28,50.86l-1.67-5.57L19.61,46l6.94-1.54,2.12,6L30,50.26l-1.23,1.22-3.64,5.3Z" />
            <polygon points="19.33 56.78 19.33 59.25 20.13 59.25 20.13 56.47 19.33 56.78" />
            <polygon class="cls-32" points="17.09 50.86 17.99 54.71 21.24 54.71 21.68 52.55 20.83 53.77 20.83 52.03 20.32 53.33 20.13 51.43 19.61 53.11 18.82 51.2 18.82 53.56 17.99 52.55 18.21 53.77 17.09 50.86" />
            <path d="M14.88,61.82a8.15,8.15,0,0,0,4.5,3.3l-.56-.88,1.31,1.19L22,64l-.78,1.13a5.93,5.93,0,0,0,3.11-3.3l-4.74-2.57Z" />
            <path class="cls-31" d="M15.2,61.4l4.41-2.15,3.5,2.15-1.87-.34,1.42,1.28-2,1.59L21,62.68l-1.23,1.25L18,62.34l.28,1.59S17,63.74,15.2,61.4Z" />
            <polygon class="cls-30" points="16.63 60.79 19.61 59.25 21.68 60.52 20.13 60.31 20.65 61.59 19.62 62.93 19.73 61.59 19.15 62.34 17.52 61.4 18.46 60.5 16.63 60.79" />
            <path class="cls-30" d="M18.59,45l-5.66-1.54,1.9,1.06L12,43.77,9.88,48.36l.65-2.3-2.8,1.59L10,45.29H7.31s2.15-2.08,3.88-2.41a11.74,11.74,0,0,1,3.64,0L13,42.08S15.22,41.42,18.59,45Z" />
            <path class="cls-29" d="M13.19,32.48l.45,5.31a4.16,4.16,0,0,1,3.19-1s-.38-.48-1.83-.28l1.12-.76-2,.65,1.49-1-1.49.55.91-.8-.91.25.73-1.2-.73.54v-1Z" />
            <path class="cls-29" d="M18.59,37.22l1.54-5.94,1.51,4.13s-2.18.44-2.12.44,2.26.36,2.26.36l-2.44.19,2.44.24-2.41,0,1.53.19-1.67.06,1.7.3Z" />
            <polygon class="cls-29" points="23.2 36.89 26.87 31.88 25.03 36.18 24.21 36.29 25.64 36.89 24.18 36.78 26.62 37.55 23.2 36.89" />
            <path class="cls-33" d="M22.77,50.86,23.94,54l1.83-1.58-1,1.93s2.57-2.91,2.55-3.51l-.93.71L27,50.29l-.69-2.59.84,1.54-.54-3.36,2.05,4.66v3.83l-2.13,2.75-1.35-.65-3.14-1.76Z" />
            <polygon class="cls-33" points="21.68 60.52 22.21 61.09 21.24 61.06 21.73 62.34 21.16 63.29 21.24 62.12 19.73 63.58 17.99 62.34 19.81 65.14 24.17 63.12 23.71 61.21 21.68 60.52" />
            <path d="M13,48.2l4.68,1.67s-.88,2-2.43,2.16S12.1,50.68,13,48.2Z" />
            <path d="M12.23,47.21s9.39,4.12,10.32,4.84v.73a50.89,50.89,0,0,0-10.9-4.58Z" />
            <path d="M22.55,52.05a10.17,10.17,0,0,0,5.12,1.51l-.31.66a11.7,11.7,0,0,1-4.81-1.44Z" />
            <path class="cls-33" d="M11.83,48.85l.47-.18.33.18s-.63,3.86,2.78,3.51a3.28,3.28,0,0,0,2.22-1.5l4.92,1.92a6.09,6.09,0,0,0,4.24,1.59l.08-.44-6.74-2.5-3.5-1.92-4-1.51h-.54Z" />
            <path class="cls-29" d="M13.78,48.39l3.39,1.47-3-1,2.74,1.65L14,49.11l2.44,1.61-2.61-1.14,1.31.91-1.54-.63,2.2,1.39-2.2-.79,1,.79-1-.42s-.79-.76-.09-2.63v1Z" />
            <polygon points="23.11 49.84 21.91 50 21.42 49.38 21.68 50.52 23.58 50.04 23.11 49.84" />
            <polygon points="17.09 49.38 18.3 49.66 18.59 49.14 18.59 50.12 17.09 49.38" />
            <polygon class="cls-31" points="21.68 50.52 22.31 50.63 22.33 51.91 22.77 50.25 21.68 50.52" />
            <path class="cls-15" d="M367.4,24.71a.51.51,0,0,1-.48.53q-10.8,0-21.59,0a.51.51,0,0,1-.48-.53c.09-10.29-.57-13.54.5-13.54,2.34,0,6.28,0,8.62,0a.64.64,0,0,0,.6-.66c0-2.57.09-6.89,0-9.51-.06-1.6,2-.76,11.62-.93.67,0,1.21.76,1.21,1.5C367.39,5.67,367.39,18.22,367.4,24.71Zm-6.26-13.55c1.56,0,3.12,0,4.68,0,.42,0,.65,0,.64-.61,0-2.63,0-5.25,0-7.88,0-.93-.19-1.12-1.12-1.12-3,0-5.93,0-8.89,0-.45,0-.64.07-.63.63,0,2.74,0,5.48,0,8.22,0,.75,0,.76.8.76Zm-4.38,1.37c-2.34,0-4.68,0-7,0-.66,0-1.08.17-1.19.93-.05.32,0,6.7,0,9.38,0,1.29.7,1.22,2.08,1.25,6.11.11,6.82.11,11.79,0,1.6,0,2.44-.33,2.45-1.82q0-4.11,0-8.22a1.33,1.33,0,0,0-1.41-1.52Zm-9.08,5.83V17c0-.46-.32-.38-.55-.34s-.37.21-.37.34c0,.79,0,1.59,0,2.38,0,.46.32.38.54.34a.54.54,0,0,0,.38-.34A6.92,6.92,0,0,0,347.68,18.36Z" />
            <path class="cls-15" d="M351.24,2.58a4.3,4.3,0,0,0,.62,0c.42,0,.53.14.52.58s-.14.51-.46.46a3,3,0,0,0-3.09,1.31c-.33.28-.35.84,0,.81,1.06-.08.15.77,0,1s-.47.58-.7.89c-.86,1.15-.87,1.15-1.43-.09-.17-.38-.28-.78-.45-1.16-.29-.68-.28-.78.36-.72s.64-.3.82-.69A3.79,3.79,0,0,1,351.24,2.58Z" />
            <path class="cls-15" d="M361,3.61H359.9c-.42,0-.36-.34-.32-.59s.19-.42.3-.42c.72,0,1.45,0,2.17,0,.42,0,.36.33.32.58s-.18.41-.3.43A7.93,7.93,0,0,1,361,3.61Z" />
            <path class="cls-15" d="M356.76,22.82h-6.25c-.41,0-.66,0-.66-.6,0-2.69,0-5.37,0-8.06,0-.57.21-.62.64-.62H363c.41,0,.66,0,.66.61,0,2.68,0,5.37,0,8.05,0,.58-.21.63-.64.62C360.92,22.81,358.84,22.82,356.76,22.82Z" />
        </g>
    </g>
</svg> -->
